import { AccountHolderRelationshipToBusiness } from '@square/dashboard-protos/models/squareup/deposits/bank_account_service';
export let Action = /*#__PURE__*/function (Action) {
  Action["Click"] = "Click";
  Action["View"] = "View";
  return Action;
}({});
export let Feature = /*#__PURE__*/function (Feature) {
  Feature["AddBankAccount"] = "Add Bank Account";
  return Feature;
}({});
export let Page = /*#__PURE__*/function (Page) {
  Page["ManualLinkingInfo"] = "Manual Linking Info";
  Page["SomethingWentWrong"] = "Something Went Wrong";
  Page["BankAccountCouldNotBeAdded"] = "Bank Account Could Not Be Added";
  Page["DirectDebitMandateForm"] = "Direct Debit Mandate Form";
  Page["PlaidIntro"] = "Plaid Intro";
  Page["PlaidPrimer"] = "Plaid Primer";
  Page["AccountSelection"] = "Account Selection";
  return Page;
}({});
export let Target = /*#__PURE__*/function (Target) {
  Target["AddAccount"] = "Add Account";
  Target["LinkInstantly"] = "Link Instantly";
  Target["Verify"] = "Verify";
  Target["Exit"] = "Exit";
  Target["Submit"] = "Submit";
  Target["Cancel"] = "Cancel";
  Target["Plaid"] = "Plaid";
  return Target;
}({});
export let Applet = /*#__PURE__*/function (Applet) {
  Applet["BankAccountSettings"] = "Bank Account Settings";
  Applet["Banking"] = "Banking";
  Applet["TransferSettings"] = "Transfer Settings";
  return Applet;
}({});
export let PlaidEventToPage = /*#__PURE__*/function (PlaidEventToPage) {
  PlaidEventToPage["OPEN"] = "Open";
  PlaidEventToPage["OPEN_OAUTH"] = "Credentials";
  PlaidEventToPage["SELECT_INSTITUTION"] = "Bank Search";
  PlaidEventToPage["SUBMIT_CREDENTIALS"] = "Credentials";
  PlaidEventToPage["SUCCESS"] = "Success";
  PlaidEventToPage["TRANSITION_VIEW"] = "Transition View";
  return PlaidEventToPage;
}({});
const getEventName = (action, feature) => `${action} ${feature}`;
const accountOwnerRoleMap = {
  businessOwnerOrBusiness: 'business_owner_or_business',
  coOwnerOrBusinessPartner: 'co_owner_or_business_partner',
  beneficialOwnerDirectorOrSimilar: 'beneficial_owner_director_or_similar',
  ownerSpouseOrDomesticPartner: 'owners_spouse_or_domestic_partner',
  parentOrganization: 'parent_organization',
  powerOfAttorneyOrGuardian: 'power_of_attorney_or_guardian',
  other: 'other_or_relationship_not_listed'
};
const accountHolderRelationshipToBusinessMap = {
  [AccountHolderRelationshipToBusiness.BUSINESS_OWNER_OR_BUSINESS]: 'business_owner_or_business',
  [AccountHolderRelationshipToBusiness.CO_OWNER_OR_BUSINESS_PARTNER]: 'co_owner_or_business_partner',
  [AccountHolderRelationshipToBusiness.BENEFICIAL_OWNER_DIRECTOR_OR_SIMILAR]: 'beneficial_owner_director_or_similar',
  [AccountHolderRelationshipToBusiness.OWNERS_SPOUSE_OR_DOMESTIC_PARTNER]: 'owners_spouse_or_domestic_partner',
  [AccountHolderRelationshipToBusiness.PARENT_ORGANIZATION]: 'parent_organization',
  [AccountHolderRelationshipToBusiness.POWER_OF_ATTORNEY_OR_GUARDIAN]: 'power_of_attorney_or_guardian',
  [AccountHolderRelationshipToBusiness.OTHER_OR_RELATIONSHIP_NOT_LISTED]: 'other_or_relationship_not_listed'
};
export function getBankLinkingEvent(action, args) {
  const feature = Feature.AddBankAccount;
  return {
    name: getEventName(action, feature),
    properties: {
      feature,
      applet: Applet.Banking,
      ...args
    }
  };
}
export function getAccountOwnerRoleName(role) {
  if (role === undefined) {
    return 'none';
  }
  if (typeof role === 'number') {
    return accountHolderRelationshipToBusinessMap[role] || 'none';
  }
  if (typeof role === 'string') {
    return accountOwnerRoleMap[role] || 'none';
  }
  return 'none';
}